import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseRestApiService } from 'src/app/service/baseRestApiService.service';
import { UrlProviderService, EndPoints } from 'src/app/service/urlprovider.service';
import { Node } from '../model/node.model';
import { WorkflowStateTypes } from '../../system/workflows/model/workflow-state-types.model';
import { LOGINDETAILS } from '../../system/accounts/model/login-audit';
import { LoginDetails } from '../../coe/model/Comment';

@Injectable({
    providedIn: 'root'
})
export class NodesService extends BaseRestApiService {
    constructor(http: HttpClient, urlProvider: UrlProviderService) {
        super(http, urlProvider);
    }

    getHistories(nodeId: number): Observable<any> {
        return this.get<any>(EndPoints.nodes_GetHistories, '', nodeId);
    }

    chooseToEditNode(node: Node): Observable<any> {
        return this.post<any>(EndPoints.nodes_chooseToEditNode, false, '', {
            node: node
        });
    }

    ChooseToNotEditNode(node: Node): Observable<any> {
        return this.post<any>(EndPoints.nodes_chooseToNotEditNode, false, '', {
            node: node
        });
    }

    deleteCoe(coeId: number): Observable<any> {
        return this.post<any>(EndPoints.nodes_deleteCoe, false, { coeId });
    }

    getEditors(nodeId: number): Observable<any> {
        return this.get<any>(EndPoints.nodes_GetEditors, '', nodeId);
    }

    show(nodeId: number): Observable<any> {
        return this.get<any>(EndPoints.nodes_Show, '', nodeId);
    }

    transition(node: Node, toState: WorkflowStateTypes, assignToUser?: LOGINDETAILS, message?: string) {
        return this.post<any>(EndPoints.nodes_Transition, false, '', {
            node: node,
            toState: toState,
            assignToUser: assignToUser,
            message: message
        });
    }

    transitionByName(node: Node, toStateName: string, assignToUser?: LOGINDETAILS): Observable<any> {
        return this.post<any>(EndPoints.nodes_TransitionByName, false, '', {
            node: node,
            toStateName: toStateName,
            assignToUser: assignToUser
        });
    }

    getComments(nodeId: number): Observable<any> {
        return this.get<any>(EndPoints.nodes_GetComments, '', nodeId);
    }

    getUsersInMyRegion(node: Node, toState: WorkflowStateTypes): Observable<any> {
        return this.post<any>(EndPoints.nodes_GetUsersInMyRegion, false, null, { node: node, toState: toState });
    }

    reassignNode(node: Node, newEditor: LOGINDETAILS): Observable<any> {
        return this.post<any>(EndPoints.nodes_ReassignNode, false, null, { node: node, newEditor: newEditor });
    }

    removeEditor(node: Node): Observable<any> {
        return this.post<any>(EndPoints.nodes_RemoveEditor, false, null, { node: node });
    }

    getWorkflowStates(node: Node): Observable<any> {
        return this.post<any>(EndPoints.nodes_GetWorkflowStates, false, null, { node: node });
    }

    changeNodeState(node: Node, toState: WorkflowStateTypes, assignToUser: LOGINDETAILS, message: string): Observable<any> {
        return this.post<any>(EndPoints.nodes_ChangeNodeState, false, null, { node: node, toState: toState, assignToUser: assignToUser, message: message });
    }
}
